import React, { forwardRef, useRef, useState } from 'react';
import { FlexCenter } from '../../layout/FlexCenter/FlexCenter';
import { Spacing } from '../../layout/Spacing/Spacing';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { Input } from '../../shared/Input/Input';
import { CleanButton } from '../../ui/CleanButton';
import { ExecButton } from '../../ui/ExecButton/ExecButton';
import { PanelLayout } from '../../layout/Panel/Panel';
import { useAppDispatch } from '../../../redux/hooks';
import { clearChatHistory } from './chatBotHistory.slice';
import { MenuButtons } from '../../shared/MenuButtons/MenuButtons';

interface IChatBotInputFormProps {
    chatResponseLoading: boolean;
    chatText: string;
    submitMessage: (e: React.FormEvent<HTMLFormElement>) => void;
    onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export const ChatBotInputForm = forwardRef<HTMLDivElement, IChatBotInputFormProps>(({ chatResponseLoading, chatText, submitMessage, onInputChange }, ref) => {
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const dispatch = useAppDispatch();
    const formRef = useRef<HTMLFormElement | null>(null);

    return (
        <div ref={ref} className="chat-bot__input-wrapper">
            {showMenu && (
                <MenuButtons showMenu={showMenu} setShowMenu={setShowMenu}>
                    <ExecButton textColor="dark" stretch size="m" iconSize={2} label={'Start new chat'} iconName={'ChatBotHistory_grey'} func={() => dispatch(clearChatHistory())} />
                    <ExecButton textColor="dark" stretch size="m" iconSize={2} label={'Info'} iconName={'Info_grey'} func={() => console.log('')} />
                </MenuButtons>
            )}

            <Spacing paddingSpacing="l" marginSpacing="none">
                <FlexCenter direction="v">
                    <CleanButton func={() => setShowMenu(!showMenu)}>
                        <IconComponent size={2} iconName={'ChatBotOptions'} />
                    </CleanButton>
                    <form ref={formRef} onSubmit={submitMessage} style={{ width: '100%' }}>
                        <FlexCenter direction="v">
                            <Input
                                loading={chatResponseLoading}
                                isDisabled={chatResponseLoading ? true : false}
                                formRef={formRef}
                                placeholder={`${chatResponseLoading ? '...waiting for answer' : 'Type some message'}`}
                                stretch
                                func={(e) => onInputChange(e)}
                                value={chatText}
                            />
                            <CleanButton disabled={chatResponseLoading ? true : false} buttonType="submit">
                                <IconComponent size={3} iconName={`${!chatResponseLoading ? 'InBot_send' : 'InBot_send_disabled'}`} />
                            </CleanButton>
                        </FlexCenter>
                    </form>
                </FlexCenter>
            </Spacing>
        </div>
    );
});

ChatBotInputForm.displayName = 'ChatBotInputForm';
export default ChatBotInputForm;
